import type { Middleware } from "@/shared/utils/middleware.util";
import { Message } from "@payping/web-components";

const defaultMessage = "متاسفانه مشکلی به وجود آمده است. لطفا دوباره امتحان کنید";

const defaultMessages: Record<number, any> = {
  400: defaultMessage,
  401: "لطفا دوباره وارد شوید",
  403: "شما دسترسی لازم برای انجام این عملیات را ندارید.",
  404: "اطلاعات درخواستی شما یافت نشد",
  412: "PreconditionFailed",
  500: "خطای سرور رخ داده است. لطفا بعدا دوباره تلاش کنید",
  // default: defaultMessage,
  // offline: "لطفا اتصال دستگاه به اینترنت را بررسی کنید",
  // timeout: "پاسخی در زمان مناسب از سرور دریافت نشد. لطفا دوباره امتحان کنید",
};

const ignoreUrls = ["/v1/refund/LatestByPaymentCode/"];

const errorMiddleware: Middleware = {
  error: async (error) => {
    try {
      const er = await error.json();

      const content = er.detail || defaultMessages[er.status] || defaultMessage;
      if (!ignoreUrls.some((prefix) => er?.instance?.includes?.(prefix)))
        Message.error({ content, duration: 2, key: er.instance });

      throw error;
    } catch {
      throw error;
    }
  },
};
export default errorMiddleware;
